import { colorBaseGreyWarm700, ProductParagraph } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { formatDate } from '../../util/date-formatter';
import DocumentContext from '../DocumentPage/DocumentContext';

const Wrapper = styled.div`
    /* Secondary text color */
    color: ${colorBaseGreyWarm700};
`;

export const PublishDate: React.FC = () => {
    const {
        document: { originalPublishDateInISOString },
    } = useContext(DocumentContext);
    const publishDate = formatDate(new Date(originalPublishDateInISOString));
    return (
        <Wrapper>
            <ProductParagraph step="negative-2">
                Published on{' '}
                <time dateTime={originalPublishDateInISOString} itemProp="datePublished">
                    {publishDate}
                </time>
            </ProductParagraph>
        </Wrapper>
    );
};
